import { FC, ReactElement } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { Tooltip } from '@gem/ui-kit';

import { TOOLTIP_SHOW_DELAY } from '../EditProfilePopup.constants';

interface IPermissionTooltip {
  children: ReactElement;
  disabled: boolean;
}

export const PermissionTooltip: FC<IPermissionTooltip> = ({ children, disabled }) => {
  const { t } = useTranslation();

  return (
    <Tooltip
      arrow={true}
      placement={'bottom'}
      delay={TOOLTIP_SHOW_DELAY}
      disabled={disabled}
      render={(): ReactElement => <div>{t('user_profile_edit_restricted')}</div>}
    >
      {children}
    </Tooltip>
  );
};
